// import Swiper JS
import Swiper, { Navigation, Mousewheel } from 'swiper';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox.css';

const $ = window.jQuery;

const BearbetningSwiper = {
	init() {
		var $heroSwiper = $(document).find('.single-stensorter .bearbetningSwiper');

		if (!$heroSwiper.length) return;

		// configure Swiper to use modules
		Swiper.use([Navigation, Mousewheel]);

		const swiper = new Swiper('.bearbetningSwiper', {
			slidesPerView: 3,
			spaceBetween: 20,
			loop: false,
			infinit: false,
			mousewheel: {
				forceToAxis: true,
			},
			grid: {
				rows: 2,
			},
			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				// when window width is >= 480px
				480: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				// when window width is >= 640px
				640: {
					slidesPerView: 6,
					spaceBetween: 20,
				},
				// when window width is >= 840px
				940: {
					slidesPerView: 7,
					spaceBetween: 20,
				},
				1700: {
					slidesPerView: 7,
					spaceBetween: 20,
				},
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});

		Fancybox.bind('[data-fancybox="bearbetning"]', {
			Thumbs: false,
			Toolbar: false,

			Image: {
				zoom: false,
				click: false,
				wheel: 'slide',
			},
		});
	},
};

export default BearbetningSwiper;
